import { networkRequest, AppAsyncAction } from 'actions/helpers';

export function sappaSignup(
  customerId: string,
  password: string,
  email: string,
): AppAsyncAction<Response> {
  return async (dispatch, getState) => {
    const { apiBaseUri } = getState().settings;

    const response: Response = await dispatch(networkRequest(`${apiBaseUri}/login/v2/auth/sappa`, 'PUT', {}, {
      vismaId: customerId,
      password,
      email: email || undefined,
    }));

    return response;
  };
}
